import { RotatingLines } from 'react-loader-spinner';

/**
 * @see https://www.npmjs.com/package/react-loader-spinner
 * @returns
 */
export default function Loading() {
  return (
    <div className="flex justify-center items-center h-24 overflow-hidden text-center">
      <RotatingLines
        strokeColor="black"
        strokeWidth="1"
        animationDuration="0.75"
        width="128"
        visible={true}
      />
    </div>
  );
}
